module.exports = __webpack_public_path__ + "static/Harpy-39806ba94cc85749ec68fadde243dbaf.jpg";